// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
  return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/interopDefault.js
// module id = 67
// module chunks = 14